export class ContestDetailModel {
    public id: number;
    public contestType: string;
    public artist: string;
    public partner: string;
    public company: string;
    public allowVoting: boolean;
    public ageLimit: number;
    public contestStartDate: string;
    public contestEndDate: string;
    public timeRemaining: string;
    public contestBanner: string;
    public contestThumbnail: string;

    public ccbTitle: string;
    public ccbDescription: string;
    public ccbStyleGuidelines: string;
    public ccbThingsRequiredToInclude: string;
    public ccbThingsShouldToAvoid: string;

    public cctName: string;
    public cctDescription: string;
    public cctAcceptableFileFormats: string;
    public cctMinimumWidth: number;
    public cctMaximumWidth: number;
    public cctMinimumHeight: number;
    public cctMaximumHeight: number;
    public cctRecommendedResolution: number;
    public hasTermAndConditions: boolean;
    public termAndConditions: string;

    public prizing: string;
    public prizingDescription: string;
    public prizingAmount: number;

    public isContestSubmittedByCurrentUser: boolean;
}



// WEBPACK FOOTER //
// ./src/models/contest/contest.detail.model.ts